import {
  useContactSales,
  useGetCREProjects,
  useGetSimulationModels,
} from '../../../../shared/hooks';

export const useCre = () => {
  const { error: errorCRE, loading: loadingCRE } = useGetCREProjects('cre');
  const { error: errorPortfolio, loading: loadingPortfolio } = useGetCREProjects('cpm');
  const { data: models } = useGetSimulationModels();

  const getModelHeader = () =>
    (models || []).find((model) => {
      const path = window.location.pathname;
      const match = `/tools/${model.shortName}`;

      return path.includes(match);
    })?.name;

  return {
    modelHeader: getModelHeader(),
    hasAccessToCREApp: loadingCRE ? false : errorCRE?.code !== 403,
    hasAccessToPortfolioApp: loadingPortfolio ? false : errorPortfolio?.code !== 403,
    contactSalesRequest: useContactSales(),
  };
};
